import { render, staticRenderFns } from "./UpdateDealer.vue?vue&type=template&id=c08e246a&scoped=true"
import script from "./UpdateDealer.vue?vue&type=script&lang=js"
export * from "./UpdateDealer.vue?vue&type=script&lang=js"
import style0 from "./UpdateDealer.vue?vue&type=style&index=0&id=c08e246a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08e246a",
  null
  
)

export default component.exports